/**
 * Form snapshot the Candid notes modal emits to its parent.
 *
 * @module candidNotesFormState
 */

/**
 * Parent-consumable state for the Candid notes form.
 *
 * `isValid` is true only when the notes field has non-blank text.
 */
export interface CandidNotesFormState {
  /** Raw notes text from the textarea. */
  notes: string;
  /** Whether the form may be submitted. */
  isValid: boolean;
}

/** Empty snapshot used before the user has entered a note. */
export const EMPTY_CANDID_NOTES_FORM_STATE: CandidNotesFormState = {
  notes: "",
  isValid: false,
};
